"use client";

import { useSectionRoleKeys } from "@/components/app/section-access-provider";
import { visibleSectionLink } from "@/lib/auth/section-access";

import { GripVertical } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";

const items = [
  { href: "/company/dispatch/dashboard", label: "Dashboard" },
  { href: "/company/dispatch/orders", label: "Orders" },
  { href: "/company/dispatch/runs", label: "Delivery runs" },
  { href: "/company/dispatch/assets", label: "Asset Tracking" },
  { href: "/company/dispatch/trackers", label: "GPS tracker devices" },
  { href: "/mobile/driver", label: "Driver workspace" },
];

export function DispatchSectionNav() {
  const roleKeys = useSectionRoleKeys();
  const pathname = usePathname();

  return (
    <nav
      aria-label="Dispatch sections"
      className="flex min-h-14 items-center gap-1.5 overflow-x-auto py-2"
    >
      {items.filter((item) => visibleSectionLink(roleKeys, item.href)).map((item) => {
        const active =
          pathname === item.href || pathname.startsWith(`${item.href}/`);
        return (
          <Link
            aria-current={active ? "page" : undefined}
            className={cn(
              "inline-flex h-9 shrink-0 items-center gap-1.5 rounded-md px-3 text-sm font-medium transition-colors",
              active
                ? "bg-[var(--color-brand)] text-white"
                : "text-[var(--color-foreground-muted)] hover:bg-[var(--color-brand-soft)] hover:text-[var(--color-brand)]",
            )}
            href={item.href}
            key={item.href}
          >
            <GripVertical aria-hidden="true" className="size-3.5" />
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
